import PublicContactUs from './public/contact-us'
export default AuthAPI

AuthAPI.$inject = ['AuthServer']
function AuthAPI(AuthServer) {
  this.server = AuthServer
  PublicContactUs(this)
}
